import {atomFamily} from 'recoil';

const loadingStateFamily = atomFamily({
  key: 'alarm_events_table_loading',
  default: true
})

const errorStateFamily = atomFamily({
  key: 'alarm_events_table_error',
  default: false
})

const rowsStateFamily = atomFamily({
  key: 'alarm_events_table_rows',
  default: [],
});

export {loadingStateFamily, errorStateFamily, rowsStateFamily}